import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import { VerifyOtpApi, VerifyOtpApi_extrareducer } from './verify-otp/index';

const initialState = {
  verifyOtpApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};

export const VerifyOtpSlice = createSlice({
  name: 'verifyOtp',
  initialState,
  extraReducers: {
    ...VerifyOtpApi_extrareducer,
  },
});

export function useVerifyOtpStore() {
  const verifyOtpApiState = useSelector(
    (state) => state.verifyOtp.verifyOtpApiState
  );

  const dispatch = useDispatch();

  return {
    verifyOtpApiState,
    VerifyOtpApi: (payload) => dispatch(VerifyOtpApi(payload)),
  };
}

export default VerifyOtpSlice.reducer;
